export default {
  name: "Заңды тұлғаның атауы",
  entity: "Заңды тұлға",
  iik: "ИИК",
  inn: "ИНН",
  bin: "БИН",
  bic: "БИК",
  bankBic: "Банк БИК-і",
  codeFiscal: "Салық коды",
  head_name_description:
    "Актілер мен шоттар автоматты түрде жасалатын жауапты адамның Т.А.Ә.-н енгізіңіз",
  mainOrganization: "Негізгі заңды тұлға",
  mainOrganizationHint:
    "Негізгі заңды тұлға тариф сатып алу үшін қолданылады және оның деактивациясы кезінде белсенді болып қалады. Негізгі заңды тұлғаны 14 күнде бір реттен жиі емес өзгертуге болады",
  chooseMainOrganization: "Заңды тұлғаны таңдаңыз",
  maxOrganizationError: "Ұйымдардың ең көп саны құрылды",
  moderOrganizationError:
    "Модерация процесі жүріп жатқан кезде жаңа ұйым қоса алмайсыз",
  aboutTitle: "Ұйымыңыз туралы ақпарат",
  typeOrganization: "Ұйым түрі",
  bankName: "Банк атауы",
  legalAddress: "Заңды мекенжай",
  currentAccountNumber: "Есеп айырысу шотының нөмірі",
  correspondentAccount: "Корреспонденттік шот",
  vatCode: "ҚҚС коды",
  addressFieldRequired: "Заңды тұлғаның мекенжайы енгізілмеген",
  metaIsRequired: "Банк деректері енгізілмеген",
  add: {
    button: "Ұйым құру",
  },
  // popup Aliexpress
  entities: "Заңды тұлғалар",
  head_name: "Басшының Т.А.Ә.",
  ogrn: "ОГРН",
  ogrnOgrnip: "ОГРН / ОГРНИП",
  legalTypes: "Заңды тұлға нысаны",
  taxSystem: "Салық салу түрі",
  monthlyTurnover: "Айлық айналым мөлшері",
  depositSum: "Депозит сомасы",
  okvedLabel: "Негізгі қызмет түрі",
  legalEntityCharter: "Заңды тұлғаның жарғысы",
  mainEntity: "Негізгі",
  mainEntityInfo: [
    "Негізгі заңды тұлға тариф сатып алу үшін қолданылады және егер оның мерзімі өткен соң жаңа тариф төленбесе, белсенді болып қалады.",
    "Негізгі заңды тұлғаны 14 күнде 1 реттен жиі емес өзгертуге болады.",
  ],
  cantCreateModal: {
    title: "Сіздің тарифіңізде ең көп заңды тұлғалар саны құрылды",
  },
  deposit: "Депозит",
  enterInnOrEntityName: "ИНН немесе заңды тұлғаның атауын енгізіңіз",
  entityCreating: "Заңды тұлға құру",
  updateEntityNotifyMessage: {
    create: "Заңды тұлға модерацияға жіберілді",
    edit: "Заңды тұлға деректері сәтті өзгертілді",
  },
  commercial: "Коммерциялық заңды тұлға",
  uncommercial: "Коммерциялық емес заңды тұлға",
  depositMinSumHint:
    "Шоттағы ең аз қалдық. Шоттан қаражатты алу кезінде {minDeposit} RC-дан кем емес сома баланста қалады.",
  entityType: "Заңды тұлға түрі",
  entityInfo: "Заңды тұлға туралы ақпарат",
  bankDetails: "Банк реквизиттері",
  frequencyMainEntityChanging:
    "Негізгі заңды тұлғаны 14 күнде 1 реттен жиі емес өзгертуге болады.",
  abailableChangeMainEntity:
    "Негізгі заңды тұлғаны өзгерту {nextChangeDate} бастап қолжетімді болады.",
  mainEntityDescription:
    "Ол тариф сатып алу үшін қолданылады және егер мерзімі өткен соң жаңа тариф төленбесе, белсенді болып қалады.",
  entityHasHalal: "Заңды тұлғаның Халал сертификаты бар",
  headNameToSendActs:
    "Актілер мен шоттар автоматты түрде жасалатын жауапты адамның Т.А.Ә.",
  certHalal: "Халал сертификаты",
  makeMainEntity: "{entityName} негізгі заңды тұлға етіп жасайсыз ба?",
  successChangedMainEntity: "Негізгі заңды тұлға сәтті өзгертілді",
  mainEntityUseForBuyingTariff:
    "Негізгі заңды тұлға тариф сатып алу үшін қолданылады және егер оның мерзімі өткен соң жаңа тариф төленбесе, белсенді болып қалады.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "«Растау» түймесін басқаннан кейін негізгі заңды тұлғаны қайта өзгертуге 14 күннен ерте болмайды.",
  cancelCreationModal: {
    title: "Заңды тұлға құруды тоқтатасыз ба?",
    subtitle:
      "Енгізілген деректер сақталмайды. Заңды тұлға құруды жалғастыру үшін «Артқа» түймесін басыңыз.",
  },
  pressBackToSave:
    "Өзгерістерді сақтау немесе өңдеуді жалғастыру үшін «Артқа» түймесін басыңыз.",
  congratulateWithCreateEntity: "Заңды тұлға құрылғанымен құттықтаймыз!",
  entityInModerationNow:
    "Қазіргі уақытта сіздің заңды тұлғаңыз тексерістен өтуде. Ол 24-тен 48 сағатқа дейін созылады.",
  toPassModerationPayBill:
    "Тексерістен өту үшін төмендегі түйме арқылы шотты жүктеп алып, осы заңды тұлғадан төлеу қажет. Сондай-ақ, сіз бұл шотты жеке кабинетте таба аласыз: «Менің кәсіпорындарым» – «Құжаттар» бөлімінде «Тестік төлем» атауымен.",
};
